import axios from "axios";

// export const mainBaseUrl = 'https://admin.creatorsdostedu.in';
// export const apiBaseUrl = 'http://localhost:3000/api/';
export const mainBaseUrl = "https://creatorsdost.com/";
export const apiBaseUrl = 'https://creatorsdostedu.in/api/';

axios.interceptors.request.use((config) => {
	if (typeof FormData === "undefined" || !(config.data instanceof FormData)) {
		return config;
	}

	const entries = Array.from(config.data.entries());
	const hasFile = entries.some(([, value]) => {
		const isFile = typeof File !== "undefined" && value instanceof File;
		const isBlob = typeof Blob !== "undefined" && value instanceof Blob;
		return isFile || isBlob;
	});

	if (!hasFile) {
		config.data = Object.fromEntries(entries);
		if (config.headers?.set) {
			config.headers.set("Content-Type", "application/json");
		} else {
			config.headers = {
				...config.headers,
				"Content-Type": "application/json",
			};
		}
	}

	return config;
});